import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { loadAllFont, checkFontLoad } from "@/common/loadFont";

Vue.prototype.$ImageUrl = (item) => {
  return item == "" ? "" : process.env.VUE_APP_BASE_API + item;
};

Vue.prototype.$GetColumn = (key) => {
  if (store.state.common_column_data == null) {
    return "";
  }
  const column = store.state.common_column_data.filter(
    (column) => column.ColumnKey == key
  );
  return column.length <= 0 ? "" : column[0].Content;
};

Vue.prototype.$MoneyFormat = (price) => {
  let val = (price / 1).toFixed(0).replace(".", ",");
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

Vue.prototype.$HandleImageError = (event) => {
  // 方法1: 使用預設圖片
  //   event.target.src = require("@/assets/img/placeholder.png");

  // 方法2: 或使用 inline SVG 佔位圖
  event.target.src =
    'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"%3E%3Crect fill="%23f3f4f6" width="64" height="64"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" fill="%239ca3af" font-size="24"%3E?%3C/text%3E%3C/svg%3E';

  // 方法3: 或隱藏圖片並添加樣式
  // event.target.style.display = 'none';
};

Vue.prototype.$PageReady = (title) => {
  PageReady(title);
};

function PageReady(title) {
  const image_el = document.querySelectorAll("img");
  image_el.forEach((item) => {
    item.alt != "" ? "" : (item.alt = title);
    item.getAttribute("width")
      ? ""
      : item.setAttribute("width", item.clientWidth);
    item.getAttribute("height")
      ? ""
      : item.setAttribute("height", item.clientHeight);
  });

  checkFontLoad();
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "page_view",
      page_title: title,
    });
  }
}

Vue.prototype.$RedirectError = () => {
  var meta = document.createElement("meta");
  meta.setAttribute("property", "prerender-status-code");
  meta.setAttribute("name", "prerender-status-code");
  meta.content = "404";
  document.getElementsByTagName("head")[0].appendChild(meta);
  router.push("/error_page");
};

Vue.prototype.$LoadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

Vue.prototype.$PreLoadImage = (src) => {
  let image_link = document.createElement("link");
  image_link.as = "image";
  image_link.rel = "preload";
  image_link.href = src;
  document.head.appendChild(image_link);
};

Vue.prototype.$LoadAllFont = () => {
  loadAllFont();
};

Vue.prototype.$CopyLink = async () => {
  document.querySelector("#CopyUrlInput").value = `${window.location.href}`;
  var copyText = document.querySelector("#CopyUrlInput");
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  await navigator.clipboard.writeText(copyText.value);
  alert("已複製連結！");
};

Vue.prototype.$ShareToFB = () => {
  window
    .open(
      `https://www.facebook.com/sharer.php?u=${window.location.href}`,
      "_blank"
    )
    .focus();
};

Vue.prototype.$ShareToLine = () => {
  window
    .open(
      `https://social-plugins.line.me/lineit/share?url=${window.location.href}`,
      "_blank"
    )
    .focus();
};

Vue.prototype.$GetTextContent = (val) => {
  var msg = val.replace(/<[^>]+>/g, ""); //去除HTML Tag
  msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
  msg = msg.replace(/&npsp;/gi, ""); //去掉npsp

  return msg.slice(0, 150) + "...";
};

// 初始化
Vue.prototype.$PageInit = (
  component,
  title = "官方網站",
  content = "",
  image = ""
) => {
  // 若網站資料已經讀取完成，則呼叫頁面初始化
  // component.$emit("load-image");
  // 監聽網站圖片讀取裝態，當狀態完成時呼叫動畫初始化
  // component.$watch("$store.state.image_loaded", (newVal) => {
  // if (newVal) {
  component.$emit("set-meta", title, content, image);
  component.$nextTick(() => {
    PageReady(title);
  });
  // }
  // });
};
